/**
 * clipping-filmstrip.js
 *
 * A slideshow player drawer for quickly navigating between slides.
 *
 */
import '../../player/00-slideshare_event_manager'

(function(window, ss, $ssEventManager, jSecure) {
  var utils = ss.utils,
      i18n = utils.i18n,

    constants = {
      FAKE_IMG_SRC: 'data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=',
      HIDE_FILMSTRIP_TIMER: 50,
      KEY_ENTER: 13,
      KEY_ESC: 27,
      KEY_ARROW_LEFT: 37,
      KEY_ARROW_RIGHT: 39
    },

    classes = {
      filmStripContainer: 'filmstrip-container',
      filmStrip: 'filmstrip',
      filmStripLens: 'filmstrip-lens',
      filmStripLensImage: 'filmstrip-lens-image',
      filmStripThumbnail: 'filmstrip-thumb',
      topClipLabel: 'top-clip-label',
      topClip: 'top-clip'
    },

    selectors = {
      filmStripContainer: '.' + classes.filmStripContainer,
      filmStripLens: '.' + classes.filmStripLens,
      filmStripLensImage: '.' + classes.filmStripLensImage,
      filmStrip: '.' + classes.filmStrip,
      filmStripThumbnail: '.' + classes.filmStripThumbnail,
      topClipLabel: '.' + classes.topClipLabel
    },

    templates = {
      filmStripContainer: jSecure.processTemplate('<div class="{className}">', {className: classes.filmStripContainer}),
      filmStripLens: jSecure.processTemplate('<div class="{className}"><img src="{src}" class="{imageClassName}"></div>', {
        className: classes.filmStripLens,
        src: constants.FAKE_IMG_SRC,
        imageClassName: classes.filmStripLensImage
      }),
      filmStrip: jSecure.processTemplate('<ul class="{className}">', {className: classes.filmStrip}),
      thumbnailContainer: 'li',
      topClippedLabel: jSecure.processTemplate('<span class="{className}">' + jSecure.htmlEncode(i18n('clipping.filmstrip.message')) + '</span>', {className: classes.topClipLabel}),
      thumbnail: jSecure.processTemplate('<img src="{src}" class="{className}">', {
        src: constants.FAKE_IMG_SRC,
        className: classes.filmStripThumbnail
      })
    },

    DEFAULT_CONFIG = {
      targetEl: null,
      progressBar: null,
      slides: null,
      slideCount: null,
      slideRatio: 4/3,
      thumbWidth: 100,
      thumbMargin: 4,
      imageInViewThreshold: 100
    },

    filmStripHideTimer;

  /**
   * Creates a new ClippingFilmStrip instance with optional configuration.
   *
   * @param {Object} config Configurable options for instance.
   * @param {Number} config.targetEl The parent element to attach filmstrip to.
   * @param {Number} config.progressBarEl The player progress bar element.
   * @param {Object} config.slides Slides from presentation with associated meta data.
   * @param {Number} config.slideCount The total number of slides in the presentation.
   * @param {Number} [config.slideRatio] The width/height ratio of all slides.
   * @param {Number} [config.thumbWidth] The width to apply to filmstrip thumbnails.
   * @param {Number} [config.thumbMargin] The margins to apply to filmstrip thumbnails.
   * @param {Number} [config.imageInViewThreshold] The amount of offscreen variance to include
   *                 when determining thumbnail visibility.
   *
   * @constructor
   */
  function ClippingFilmStrip(config) {
    this.config = $.extend({}, DEFAULT_CONFIG, config);

    if ($('#new-player').length === 1) {
      return;
    }

    if (!(this.config.targetEl && this.config.progressBarEl &&
          this.config.slides && this.config.slideCount)) {
      throw new Error('ClippingFilmStrip missing config dependencies.');
    }

    if (!$ssEventManager) {
      throw new Error('ClippingFilmStrip missing global dependency: $ssEventManager.');
    }

    this._init();
  }

  ClippingFilmStrip.prototype = /** @lends ClippingFilmStrip.prototype */ {

    constructor: ClippingFilmStrip,

    /**
     * Adds event handlers required by ClippingFilmStrip
     *
     * @returns {Void}
     */
    _attachEventListeners: function() {
      this.$progressBar
        .on('mousemove.filmstrip', this._onProgressBarMouseMove.bind(this))
        .on('mouseleave.filmstrip', this._setFilmStripHideTimer.bind(this))
        .on('click', this._onProgressBarClick.bind(this))
        .on('mousedown', this._onProgressBarMouseDown.bind(this))
        .on('keydown', this._onProgressBarKeyDown.bind(this))
        .on('keyup', this._onProgressBarKeyUp.bind(this))
        .on('focusout', this._hideFilmStripByKeys.bind(this));

      this.$filmStripContainer
        .on('mouseenter.filmstrip', this._clearFilmStripHideTimer.bind(this))
        .on('mouseleave.filmstrip', this._setFilmStripHideTimer.bind(this))
        .on('click', selectors.filmStripThumbnail, this._onThumbnailClick.bind(this))
        .on('click', selectors.filmStripLensImage, this._onThumbnailClick.bind(this));

      $(window)
        .on('resize.filmstrip', Foundation.utils.throttle( this._onWindowResize.bind(this), 300));
    },

    /**
     * Generates a filmstrip thumbnail with slide data.
     * @param {Object} item A data representation of a presentation slide.
     * @param {Boolean} item.isTopClip Whether or not the slide is a top clipped slide.
     * @param {Number} item.position  The slide position (1-indexed) in the presentation.
     * @param {String} item.thumbUrl An absolute url of the thumbnail image.
     *
     * @returns {jQuery} The thumbnail template
     */
    _createThumbnail: function(item) {
      var itemClass = item.isTopClip ? classes.topClip : '',
        content = [
          $(templates.thumbnail)
            .data({
              'src': item.thumbUrl,
              'position': item.position
            })
            .addClass(itemClass)
        ];

      if (item.isTopClip) {
        content.push($(templates.topClippedLabel));
      }

      return $(document.createElement(templates.thumbnailContainer)).append(content);
    },

    /**
     * Calculates the total filmstrip width.
     * @param {Number} count The amount of slides in the presentation.
     *
     * @returns {Number} The filmstrip width in pixels.
     */
    _calcFilmStripWidth: function (count) {
      var margin = this.config.thumbMargin,
        totalThumbWidth = this.config.thumbWidth * count,

        // Include left/right margin for each thumb
        totalMarginWidth = (margin * count * 2);

      return totalThumbWidth + totalMarginWidth;
    },

    /**
     * Calculates how many pixels to move filmstrip per mouse move. This is necessary
     * due to UX expectations. When user moves pointer across length of progress bar,
     * its expected all slides will be sorted through.
     *
     * Eg. When pointer is at far left side, first slide should be at center of stage.
     * When pointer is at far right side, last slide should be at center of stage.
     *
     * @returns {Number} Amount of pixels to move per one pixel mouse move.
     */
    _calcMoveByRatio: function() {
      return Math.abs(this.dimensions.filmStripWidth / this.dimensions.progressBarWidth);
    },

    /**
     * Clears global hide filmstrip timeout function, if one exists.
     *
     * @returns {Void}
     */
    _clearFilmStripHideTimer: function() {
      clearTimeout(filmStripHideTimer);
    },

    /**
     * The starting point for the filmstrip template creation. Builds out the
     * entire filmstrip, including all filmstrip thumbnails and the filmstrip
     * lens component attaches them to target DOM element.
     *
     * @returns {jQuery} The filmstrip template wrapped in a containing element.
     */
    _createFilmStrip: function() {
      var $filmStripContainer = $(templates.filmStripContainer),
        $filmStripLens = $(templates.filmStripLens),
        $filmStrip = $(templates.filmStrip),
        $topClippedLabel = $(templates.topClippedLabel);

      if (this.slides) {
        $.each(this.slides, function(idx, item) {
          $filmStrip
            .append(this._createThumbnail(item));
        }.bind(this));

        $filmStripLens.append($topClippedLabel);

        $filmStripContainer
          .append($filmStripLens, $filmStrip)
          .hide();

        this.$target.append($filmStripContainer);

        // Cache filmstrip related selectors
        this.$filmStripContainer = $(selectors.filmStripContainer);
        this.$filmStrip = this.$filmStripContainer.find(selectors.filmStrip);
        this.$filmStripItems = this.$filmStrip.find('li');
        this.$filmStripImagesQueue = this.$filmStripImages = this.$filmStripItems.find('img');

        this.$filmStripLens = this.$filmStripContainer.find(selectors.filmStripLens);
        this.$filmStripLensImage = this.$filmStripLens.find('img');

        return $filmStripContainer;
      }
    },

    /**
     * Disables interactions on the filmstrip and hides it.
     *
     * @returns {Void}
     */
    disable: function() {
      this.enabled = false;
      this._hideFilmStrip();
    },

    /**
     * Enables interactions on the filmstrip.
     *
     * @returns {Void}
     */
    enable: function() {
      this.enabled = true;
    },

    /**
     * Caches filmstrip related dimensions after a filmstrip component has been
     * attached to the page.
     *
     * @returns {Void}
     */
    _cacheDimensions: function() {
      var $progressBar = this.$progressBar,
        $filmStrip = this.$filmStrip,
        filmStripWidth = $filmStrip.width(),
        progressBarWidth = $progressBar.width(),
        progressBarOffset = $progressBar.offset(),
        baseLeftOffset = (progressBarWidth / 2) - this.config.thumbMargin;

      this.dimensions = {
        filmStripWidth: filmStripWidth,
        progressBarWidth: progressBarWidth,
        progressBarOffset: progressBarOffset,
        baseLeftOffset: baseLeftOffset
      };
    },

    /**
     * Determines slide ratio by loading a thumbnail image to determine it's
     * natural width and height. Useful when thumbnails have no layout yet.
     *
     * @returns {Promise} On resolve, returns natural width and height of image.
     */
    _getSlideRatio: function() {
      var defer = $.Deferred(),
        image = new Image(),
        slideUrl = this.slides[1].thumbUrl;

      $(image).load(function() {
        return defer.resolve({
          naturalWidth: image.width,
          naturalHeight: image.height
        })
      });

      image.src = slideUrl;
      return defer.promise();
    },

    /**
     * Given the current cursor location, determines the left offset value relative
     * to the progress bar.
     *
     * @param {Object} event Event object generated from an event listener.
     *
     * @returns {Number} The relative left offset of cursor.
     */
    _getCursorRelativeLeftOffset: function(event) {
      return Math.max(0, (event.pageX - this.dimensions.progressBarOffset.left));
    },

    /**
     * Given the current cursor location, determines which slide would be triggered
     * if progress bar was clicked.
     *
     * @param {Object} event Event object generated from an event listener.
     *
     * @returns {Number} The slide position the mouse is currently hovering over.
     */
    _getCursorSlidePosition: function(event) {
      return Math.max(1, Math.ceil(this._getCursorRelativeLeftOffset(event) / this.dimensions.progressBarWidth * this.slideCount));
    },

    /**
     * Convenience method for triggering $.slideshareEventManager 'gotoslide' event.
     * @param {Number} position The slide index to advance to.
     *
     * @returns {Void}
     */
    _goToSlide: function(position) {
      if ($ssEventManager && position) {
        $ssEventManager.trigger('gotoslide', {index: position});
        $ssEventManager.trackEvent('progressbar_click');
      }
    },

    /**
     * Convenience method for hiding the filmstrip.
     *
     * @returns {Void}
     */
    _hideFilmStrip: function() {
      this.$filmStripContainer.hide();
    },

    /**
     * Initializes the filmstrip
     *
     * @returns {void}
     */
    _init: function() {
      this.slides = this.config.slides;
      this.slideCount = this.config.slideCount;
      this.enabled = true;
      this.previewSlideIndex = 1;

      this.$target = $(this.config.targetEl);
      this.$progressBar = $(this.config.progressBarEl);

      if (!(this.$target.length && this.$progressBar.length)) {
        throw new Error('ClippingFilmStrip failed to initialize.');
      }

      // We need slide ratio to correctly set up filmstrip dimensions
      this._getSlideRatio()
        .then(function(response) {
          this._setSlideRatio({
            width: response.naturalWidth,
            height: response.naturalHeight
          });
          this._createFilmStrip();
          this._setDimensions();
          this._cacheDimensions();
          this._attachEventListeners();
        }.bind(this));
    },

    /**
     * Determines if a given filmstrip thumbnail is currently visible to the user.
     * @param {Number} el A thumbnail element to measure.
     * @param {Number} threshold The amount of offscreen buffer to include, if any.
     *
     * @returns {void}
     */
    isImageInView: function(el, threshold) {
      var $thumb = $(el),
        threshold = threshold || 0,
        containerLeftOffset = this.$target.offset().left,
        containerRightOffset = containerLeftOffset + this.$target.width(),
        thumbLeftOffset = $thumb.offset().left,
        thumbRightOffset = thumbLeftOffset + $thumb.width(),
        isInLeftBounds = (thumbRightOffset + threshold >= containerLeftOffset),
        isInRightBounds = (thumbLeftOffset - threshold <= containerRightOffset);

      return isInLeftBounds && isInRightBounds;
    },

    /**
     * Lazy loads images in the filmstrip if their thumbnail is visible in the
     * player stage area.
     *
     * @returns {void}
     */
    _loadImagesInView: function() {
      var imagesQueue = this.$filmStripImagesQueue,
        $filmStripContainer = this.$filmStripContainer,
        isFilmStripHidden = this._isFilmStripHidden(),
        threshold = this.config.imageInViewThreshold,
        imagesInView;

      // Temporarily give filmstrip layout so image offsets can be measured
      if (isFilmStripHidden) {
        $filmStripContainer.css({display: 'block', opacity: 0});
      }

      imagesInView = imagesQueue.filter(function(idx, el) {
        return this.isImageInView(el, threshold);
      }.bind(this));

      // Load revealed images
      $.each(imagesInView, function(idx, el) {
        $(el).attr('src', $(this).data('src'));
      });

      this.$filmStripImagesQueue = imagesQueue.not(imagesInView);

      if (isFilmStripHidden) {
        $filmStripContainer.css({display: 'none', opacity: 1});
      }
    },

    /**
     * Event callback for handling mousemove events on player progress bar.
     *
     * @param {Object} event
     *
     * @returns {void}
     */
    _onProgressBarMouseMove: function(event) {
      if (this.enabled) {
        clearTimeout(filmStripHideTimer);
        this._moveFilmStrip(event);
        this._showFilmStrip();
      }
    },

    /**
     * Event callback for handling clicks on player progress bar.
     * @param {Object} event
     *
     * @returns {void}
     */
    _onProgressBarClick: function(event) {
      this._goToSlide(this._getCursorSlidePosition(event));
    },

    /**
     * Event callback for handling window resizes.
     *
     * @returns {void}
     */
    _onWindowResize: function(event) {
      this._cacheDimensions();
    },

    /**
     * Event callback for handling clicks on filmstrip thumbnails.
     * @param {Object} event
     *
     * @returns {void}
     */
    _onThumbnailClick: function(event) {
      var $target = $(event.target),
        position = $target.data('position');

      if (position) {
        this._goToSlide(position);
      }

      this._hideFilmStrip();
    },

    /**
     * Sets filmstrip related dimensions before filmstrip is revealed.
     *
     * @returns {void}
     */
    _setDimensions: function() {
      var thumbWidth = this.config.thumbWidth,
        thumbMargin = this.config.thumbMargin,
        slideRatio = this.slideRatio;

      this.$filmStripItems
        .css('margin', thumbMargin);

      this.$filmStripImages
        .css({
          width: thumbWidth,
          height: thumbWidth / slideRatio
        });

      // Lens should measure 2x size of thumbnail
      this.$filmStripLens
        .css({
          width: (thumbWidth * 2) + (thumbMargin * 4),
          height: ((thumbWidth / slideRatio) * 2) + (thumbMargin * 4)
        });

      this.$filmStrip
        .css('width', this._calcFilmStripWidth(this.slideCount));
    },

    /**
     * Sets and assigns a timer for closing filmstrip if user leaves the
     * filmstrip area.
     *
     * @returns {void}
     */
    _setFilmStripHideTimer: function() {
      filmStripHideTimer = setTimeout(this._hideFilmStrip.bind(this), constants.HIDE_FILMSTRIP_TIMER);
    },

    /**
     * Sets the slide ratio property. The slide ratio is important for determining
     * thumbnail heights and maintaining a proper aspect ratio.
     * @param {Object} dimensions
     * @param {Number} dimensions.width
     * @param {Number} dimensions.height
     *
     * @returns {void}
     */
    _setSlideRatio: function(dimensions) {
      if (dimensions.width && dimensions.height) {
        this.slideRatio = this.config.slideRatio = dimensions.width/dimensions.height;
      }
    },

    /**
     * Convenience method for hiding the filmstrip.
     *
     * @returns {Void}
     */
    _showFilmStrip: function() {
      this.$filmStripContainer.show();
    },

    /**
     * Updates the filmstrip lens preview image.
     * @param {Number} position The slide index (1-indexed) to preview.
     *
     * @returns {void}
     */
    _updateFilmStripLens: function(position) {
      var updatedImageUrl = this.slides[position].thumbUrl,
        isTopClip = this.slides[position].isTopClip;

      if (updatedImageUrl) {
        this.$filmStripLens.toggleClass('top-clip', isTopClip);
        this.$filmStripLensImage
          .attr('src', updatedImageUrl)
          .data('position', position);
      }
    },

    /**
     * Offsets the filmstrip position either left and right depending on mouse location.
     * @param {Object} event Event object generated from mouse move event listener on progress bar.
     * @private
     */
    _moveFilmStrip: function(event) {
      var cursorRelativeLeftOffset = this._getCursorRelativeLeftOffset(event),
        cursorSlidePosition = this._getCursorSlidePosition(event),
        moveByOffset = (this.dimensions.baseLeftOffset) - (cursorRelativeLeftOffset * this._calcMoveByRatio());

      this._clearFilmStripHideTimer();
      this._updateFilmStripLens(cursorSlidePosition);

      if (this.$filmStripImagesQueue.length) {
        this._loadImagesInView();
      }

      this.$filmStrip.css('marginLeft', moveByOffset);
    },

    /**
     * Parses specific keys to provide an accessible means of previewing slides.
     * @param {Object} event Event object generated from keyup event listener on progress bar.
     */
    _onProgressBarKeyUp: function(event) {
      var key = event.which;

      switch (key) {
        case constants.KEY_ARROW_RIGHT:
          // Preview function is enable by pressing Shift + Arrow Key.
          if (event.shiftKey) {
            event.stopPropagation();
            this._onProgressBarRightArrowKey();
          }
          break;
        case constants.KEY_ARROW_LEFT:
          // Preview function is enable by pressing Shift + Arrow Key.
          if (event.shiftKey) {
            event.stopPropagation();
            this._onProgressBarLeftArrowKey();
          }
          break;
        case constants.KEY_ENTER:
          this._onProgressBarEnterKey();
          break;
        case constants.KEY_ESC:
          this._hideFilmStrip();
          break;
        default:
      }
    },

    /**
     * Prevents Shift key text selection.
     * @param {Object} event Event object generated from keydown event listener on progress bar.
     */
    _onProgressBarKeyDown: function(event) {
      var key = event.which;

      if (key === constants.KEY_ARROW_LEFT || key === constants.KEY_ARROW_RIGHT) {
        event.preventDefault();
      }
    },

    /**
     * Displays filmstrip, or advances preview to previous slide.
     */
    _onProgressBarRightArrowKey: function() {
      if (this.previewSlideIndex < this.config.slideCount) {
        if (!this._isFilmStripHidden()) {
          this.previewSlideIndex++;
        }
      }
      this._moveFilmStripByKeys();
    },

    /**
     * Displays filmstrip, or advances preview to next slide.
     */
    _onProgressBarLeftArrowKey: function() {
      if (this.previewSlideIndex > 1) {
        if (!this._isFilmStripHidden()) {
          this.previewSlideIndex--;
        }
      }
      this._moveFilmStripByKeys();
    },

    /**
     * Handles the mechanics of visually moving film strip.
     */
    _moveFilmStripByKeys: function() {
      var slideWidthOnBar = this.dimensions.progressBarWidth / this.config.slideCount,
        simPageX = Math.floor(this.dimensions.progressBarOffset.left + this.previewSlideIndex * slideWidthOnBar);

      this._onProgressBarMouseMove({
        pageX: simPageX
      });
    },

    /**
     * Activate and go to the slide being previewed.
     */
    _onProgressBarEnterKey: function() {
      if (!this._isFilmStripHidden()) {
        this._goToSlide(this.previewSlideIndex);
        this._hideFilmStrip();
      }
    },

    /**
     * Hides film strip that was enabled by keys.
     */
    _hideFilmStripByKeys: function() {
      this._hideFilmStrip();
      this.previewSlideIndex = 1;
    },

    /**
     * Convenience method for determining whether film strip container is hidden.
     *
     * @returns {Boolean} True value specifies container is hidden. False value specifies container is visible.
     */
    _isFilmStripHidden: function() {
      return this.$filmStripContainer.is(':hidden');
    },

    /**
     * Prevents progress bar from stealing focus after mouse click.
     * @param {Object} event Event object generated from mousedown event listener on progress bar.
     */
    _onProgressBarMouseDown: function(event) {
      event.preventDefault();
    }

  };

  utils.exports('ClippingFilmStrip', ClippingFilmStrip);

}(window, window.slideshare_object, $.slideshareEventManager, window.jSecure));
